/*=========================================================================================
  File Name: moduleVariables.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from "./moduleVariablesState.js"
import mutations from "./moduleVariablesMutations.js"
import actions from "./moduleVariablesActions.js"
import getters from "./moduleVariablesGetters.js"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

